import { IconSolarPanel2 } from "@tabler/icons-react";
import { formatEnergyValue } from "../../../utils/formatEnergyValue";
import { useStartPageDeliveredElectricity } from "../hooks/useStartPageDeliveredElectricity";
import type { MiniTileItem } from "./MiniTile";
import { MiniTile } from "./MiniTile";

type DeliveredElectricityMiniTileProps = {
  projectId?: string;
  year: number;
};

function DeliveredElectricityMiniTile({
  projectId,
  year
}: DeliveredElectricityMiniTileProps) {
  const { data, isLoading } = useStartPageDeliveredElectricity(year, projectId);

  const items: Array<MiniTileItem> = [
    {
      label: "Direktlieferung",
      value: data ? formatEnergyValue(data.sum_direct ?? 0) : ""
    },
    {
      label: "Weiterleitung",
      value: data ? formatEnergyValue(data.sum_forwarded ?? 0) : ""
    }
  ];

  return (
    <MiniTile
      icon={<IconSolarPanel2 />}
      iconColor="warning"
      isLoading={isLoading}
      items={items}
      title="Gelieferte Strommengen"
    />
  );
}

export { DeliveredElectricityMiniTile };
